package com.ustadmobile.core.db.dao

object LanguageDaoCommon {

    const val SORT_LANGNAME_ASC = 1

    const val SORT_LANGNAME_DESC = 2

    const val SORT_TWO_LETTER_ASC = 3

    const val SORT_TWO_LETTER_DESC = 4

    const val SORT_THREE_LETTER_ASC = 5

    const val SORT_THREE_LETTER_DESC = 6


}